import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import * as Actions from '../actions'

export class ResetCell extends GridCell {
  public render() {
    return <td onClick={() => {
        if (Actions.confirmAction()) {
          return this.props.dataItem.dispatch(Actions.refreshUserKey(
            this.props.dataItem.community_identifier,
            this.props.dataItem.key));
        }
      }
    }>
      <div className="r-user-reset" title="Refresh Key"><i className={`fas fa-sync`}></i></div>
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-settings/render/refresh_key.tsx